import React from "react";
import * as Mui from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { RootState } from "redux/store";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { getLeadActivitiesChronological, getLeadsByUnassignedAgent } from "redux/selector";
import { ActivityCard } from "component/page/lead-activity/activity-card";
import { urls } from "routes/urls";
import { RouterLinkWrapper } from "component/shared/router-link-wrapper";
import { LoadingIndicator } from "component/shared/loading-indicator";
import { getLeadsByAgentId } from "redux/selector";
import { AppCard } from "component/shared/app-card";
import { fetchLeads } from "redux/slice/leads";
import { fetchLeadActivities } from "redux/slice/lead-activities";

const mapStateToProps = (state: RootState) => {
	const agentId = state.agents.value;
	const unassigned = agentId === -1;
	const hasData = Object.keys(state.leadActivities.byId).length > 0;
	return {
		leadActivities: getLeadActivitiesChronological(state),
		loading: state.leadActivities.loading,
		hasData,
		leadsByAgent: getLeadsByAgentId(state, agentId),
		agentId,
		leadsByUnassigned: getLeadsByUnassignedAgent(state),
		unassigned,
	};
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
	fetchLeads,
	fetchLeadActivities,
}, dispatch);

interface Props extends
	ReturnType<typeof mapStateToProps>,
	ReturnType<typeof mapDispatchToProps>
{
}

class Component extends React.Component<Props> {

	private handleRefresh = () => {
		this.props.fetchLeads();
		this.props.fetchLeadActivities({});
	};

	public render() {
		const { leadActivities, loading, hasData, leadsByAgent, agentId, leadsByUnassigned, unassigned } = this.props;
		let fiveLeadActivities = [];
		let targetLeads = unassigned ? leadsByUnassigned : leadsByAgent;

		for (let activity of leadActivities) {
			if (fiveLeadActivities.length < 5 && (unassigned || agentId ? targetLeads.some(lead => lead.id === activity.leadId) : true)) {
				fiveLeadActivities.push(activity);
			}
			if (fiveLeadActivities.length >= 5) {
				break;
			}
		}

		const showInitialSpinner = !!loading && !hasData;

		return (
			<Mui.Grid container direction="column" spacing={2} >
				<Mui.Grid item>
					<Mui.Grid container alignItems="center" spacing={1}>
						<Mui.Grid item>
							<Mui.Typography variant="h3">Lead Activity</Mui.Typography>
						</Mui.Grid>
						<Mui.Grid item>
							<Mui.IconButton size="small" onClick={this.handleRefresh} disabled={!!loading}>
								{loading ? <Mui.CircularProgress size={16} /> : <RefreshIcon fontSize="small" />}
							</Mui.IconButton>
						</Mui.Grid>
					</Mui.Grid>
				</Mui.Grid>
				<Mui.Grid item xs>
					{showInitialSpinner &&
						<AppCard><Mui.CardContent>
								<Mui.Grid container justifyContent="center">
									<Mui.Grid item>
										<LoadingIndicator />
									</Mui.Grid>
								</Mui.Grid>
						</Mui.CardContent></AppCard>
					}
					{!showInitialSpinner && !fiveLeadActivities.length &&
						<AppCard><Mui.CardContent>
								<Mui.Grid container justifyContent="center">
									<Mui.Grid item>
										<Mui.Typography align="center">Lead activity has not yet been recorded on your site.</Mui.Typography>
									</Mui.Grid>
								</Mui.Grid>
						</Mui.CardContent></AppCard>
					}
					{!showInitialSpinner && !!fiveLeadActivities.length &&
						<Mui.Grid container direction="column" spacing={4}>
							{fiveLeadActivities.map((activity, index) => (
								<Mui.Grid key={index} item xs>
									<ActivityCard activity={activity} showLeadName />
								</Mui.Grid>
							))}
							<Mui.Grid item style={{textAlign: "center"}}>
								<Mui.Link
									component={RouterLinkWrapper}
									to={urls.leadActivity}
								>
									<Mui.Button
										color={"primary"}
										variant="contained"
									>
										View All
									</Mui.Button>
								</Mui.Link>
							</Mui.Grid>
						</Mui.Grid>
					}
				</Mui.Grid>
			</Mui.Grid>
		);
	}

}

export const LeadActivity = connect(mapStateToProps, mapDispatchToProps)(Component);
